(function () {
  var STORAGE_KEY = 'us_staleks_breadcrumb_ctx';
  var TTL_MS = 15 * 60 * 1000;

  function getCollectionHandleFromPath() {
    var parts = location.pathname.split('/').filter(Boolean);
    var i = parts.indexOf('collections');
    if (i === -1) return '';
    return parts[i + 1] || '';
  }

  function cacheCollectionHandle() {
    if (location.pathname.indexOf('/collections/') === -1) return;
    var handle = getCollectionHandleFromPath();
    if (!handle || handle === 'all') return;
    var payload = { h: handle, exp: Date.now() + TTL_MS };
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (e) {}
  }

  function applyCachedCollectionToBreadcrumb() {
    var link = document.querySelector('a[data-breadcrumb="collection"]');
    if (!link || link.getAttribute('data-from-url') === 'true') return;

    var el = document.getElementById('breadcrumb-product-collections');
    if (!el) return;

    var list;
    try {
      list = JSON.parse(el.textContent);
    } catch (e) {
      return;
    }
    if (!Array.isArray(list) || !list.length) return;

    var raw;
    try {
      raw = localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return;
    }
    if (!raw) return;

    var cached;
    try {
      cached = JSON.parse(raw);
    } catch (e) {
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch (err) {}
      return;
    }
    if (!cached.h || !cached.exp) return;
    if (cached.exp < Date.now()) {
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch (e) {}
      return;
    }

    for (var i = 0; i < list.length; i++) {
      if (list[i].handle === cached.h) {
        link.setAttribute('href', list[i].url);
        link.textContent = list[i].title;
        return;
      }
    }
  }

  cacheCollectionHandle();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyCachedCollectionToBreadcrumb);
  } else {
    applyCachedCollectionToBreadcrumb();
  }
})();
